<section class="my-4 shadow border rounded-3 bg-white overflow-hidden">
  <header class="p-3 text-primary-emphasis d-flex align-items-center bg-light border-bottom">
    <h5 class="m-0">Описание</h5>
  </header>
  <main class="p-3">
    @if (adDetails.specificationOptions.length !== 0) {
      <ul class="list-unstyled d-flex flex-wrap gap-3">
        @for (specificationOption of adDetails.specificationOptions; track specificationOption.adSpecificationId) {
          <li class="">
            <span>
              {{ specificationOption.adSpecificationName }}:
            </span>
            <span class="badge bg-primary-subtle text-dark">
              {{ specificationOption.adSpecificationOptionName }}
            </span>
          </li>
        }
      </ul>
      <hr/>
    }
    <p class="m-0"
       [style.white-space]="'pre-line'"
       [class.text-muted]="!adDetails.description">
      {{ !!adDetails.description ? adDetails.description : 'Няма предоставено описание.' }}
    </p>
  </main>
</section>
<section class="my-4 shadow border rounded-3 bg-white overflow-hidden">
  <header class="p-3 text-primary-emphasis d-flex align-items-center bg-light border-bottom">
    <h5 class="m-0">Плащане и доставка</h5>
  </header>
  <main class="p-3">
    <div>
      <i class="me-2 text-secondary fa-solid fa-map-location-dot"></i>
      <span>Местоположение: </span>
      <span class="fw-medium">{{ adDetails.populatedPlaceName }}</span>
    </div>
    <div class="pt-2">
      <i class="me-2 text-secondary fa-solid fa-money-bill-wave"></i>
      <span>Предпочитан начин за плащане: </span>
      @if (adDetails.paymentOptions.length === 0) {
        <span class="text-muted">Няма предоставен начин за плащане.</span>
      } @else {
        <ul class="list-unstyled ms-2 mb-0 pt-1">
          @for (paymentOption of adDetails.paymentOptions; track paymentOption.adPaymentOptionId) {
            <li class="mb-1 fw-medium">
              <i class="text-success fa-solid fa-check"></i>
              {{ paymentOption.adPaymentOptionName }}
            </li>
          }
        </ul>
      }

    </div>
    <div class="m-0 pt-2">
      <i class="me-2 text-secondary fa-solid fa-truck"></i>
      <span>Предпочитан начин за доставка: </span>
      @if (adDetails.deliveryOptions.length === 0) {
        <span class="text-muted">Няма предоставен начин за доставка.</span>
      } @else {
        <ul class="list-unstyled ms-2 mb-0 pt-1">
          @for (deliveryOption of adDetails.deliveryOptions; track deliveryOption.adDeliveryOptionId) {
            <li class="mb-1 fw-medium">
              <i class="text-success fa-solid fa-check"></i>
              {{ deliveryOption.adDeliveryOptionName }}
            </li>
          }
        </ul>
      }
    </div>
    @if (adDetails.paymentAndDeliveryInfo) {
      <hr/>
      <div class="m-0"
           [style.white-space]="'pre-line'">
        {{ adDetails.paymentAndDeliveryInfo }}
      </div>
    }
  </main>
</section>
@if (adDetails.additionalAdInfo) {
  <section class="my-4 shadow border rounded-3 bg-white overflow-hidden">
    <header class="p-3 text-primary-emphasis d-flex align-items-center bg-light border-bottom">
      <h5 class="m-0">Допълнителна информация</h5>
    </header>
    <main class="p-3">
      <p class="m-0"
         [style.white-space]="'pre-line'">
        {{ adDetails.additionalAdInfo }}
      </p>
    </main>
  </section>
}
